import { lazy } from 'react'

export const FieldMappingInstancePageLazy = lazy(() => import('./FieldMappingInstances'))
